module.exports = __webpack_public_path__ + "static/media/logo_face.c60d15a3.png";